export const ChipChevron = ({ rotation }: { rotation?: number }) => {
  return (
    <svg
      style={{ transform: `rotate(${rotation ?? 0}deg)` }}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_13459_6781"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13459_6781)">
        <path
          d="M10 12.5177C9.89959 12.5177 9.80612 12.5017 9.71959 12.4696C9.63306 12.4375 9.55077 12.3825 9.47271 12.3046L5.72751 8.55938C5.61223 8.44396 5.5532 8.29889 5.55042 8.12417C5.54778 7.94958 5.60681 7.80188 5.72751 7.68104C5.84834 7.56035 5.99473 7.5 6.16667 7.5C6.33862 7.5 6.48501 7.56035 6.60584 7.68104L10 11.0754L13.3942 7.68104C13.5096 7.56576 13.6547 7.50674 13.8294 7.50396C14.004 7.50132 14.1517 7.56035 14.2725 7.68104C14.3932 7.80188 14.4535 7.94826 14.4535 8.12021C14.4535 8.29215 14.3932 8.43854 14.2725 8.55938L10.5273 12.3046C10.4492 12.3825 10.367 12.4375 10.2804 12.4696C10.1939 12.5017 10.1004 12.5177 10 12.5177Z"
          fill="#62636A"
        />
      </g>
    </svg>
  );
};
